export default () => ({
  all: [],
  available: null,
  current: null,
  filter: {
    name: null,
    parent: null,
  },
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
  },
});
